import { createContext } from 'react';
import { createStore, StoreApi } from 'zustand';

export type LinkDefinitions = {
  link: string;
  id: string;
};

export type Disclaimer = {
  type: string;
  linkDefs: LinkDefinitions[];
};

export type PartnerConfig = {
  friendlyName?: string;
  expertNumber?: string;
  logoLink?: string;
  logoFileName?: string;
  showDisclaimer?: boolean;
  showLegalCheckbox?: boolean;
  customDisclaimer?: Disclaimer;
  hideClaimLink?: boolean;
  carrierPinNote?: string;
};

export type PartnerProps = PartnerConfig & {
  partner: string;
  initialized: boolean;
};

export type PartnerStore = StoreApi<PartnerProps>;

export const createPartnerStore = (state: PartnerProps): PartnerStore =>
  createStore<PartnerProps>(() => state);

export const PartnerContext = createContext<PartnerStore | null>(null);
